import { Component } from "@angular/core";
import { XOArrayField } from './xo-array-field.component';

@Component({
    selector: "xo-field-array-timestamp",
    templateUrl: "./xo-field-array-timestamp.component.html"
})
export class XOArrayFieldTimestamp extends XOArrayField {
    convertStringToDate(convertable: any) {
        return new Date(convertable.value);
    }
}
